import CodeServiceModel   from '@/models/CodeServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';

export type CodeKindReference = 'ticket' | 'exchange';

@model.urnResource('code_kind')
@doc.path('/code_kinds/{?id}')
export default class CodeKindModel extends CodeServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'label': string;
		'reference': CodeKindReference;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
		'reference': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: CodeKindReference;
}
